
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./restaurant.resolver.cjs.production.min.js')
} else {
  module.exports = require('./restaurant.resolver.cjs.development.js')
}
